import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const InvoicesTableHeaders = [
  {
    title: '#ID',
    align: 'start',
    key: 'id',
    placeholder: '00000',
  },
  {
    title: 'Status',
    align: 'start',
    key: 'invoiceStatus',
    sortable: true,
    placeholder: null,
  },
  {
    skeletonOnly: true,
    title: 'Status',
    align: 'start',
    key: 'status',
    sortable: true,
    placeholder: 6,
  },
  {
    title: 'Contact',
    align: 'start',
    key: 'contactData',
    sortable: false,
    placeholder: '######## ##########',
  },
  {
    title: 'Total',
    align: 'start',
    key: 'SERVICE_BILLING_GROSS',
    sortable: false,
    placeholder: '0.00',
  },
  {
    title: 'Issued Date',
    align: 'start',
    key: 'SERVICE_DATE',
    sortable: false,
    placeholder: '00/00/0000',
  },
  {
    title: 'Actions',
    align: 'end',
    key: 'actions',
    sortable: false,
  },
] as const satisfies readonly TableHeaderSpec[]
